<template>
    <div id="content-admin-search" class="flex flex-row items-center px-4 py-2 border-b border-theme-level2">

        <flash-message :position="'right bottom'" style="z-index: 999999999;" class="p-6"></flash-message>

        <span class="text-sm text-theme-discrete font-bold">{{ translate('admin-search') }}</span>
        <input
            type="text"
            name="searchquery"
            class="ml-4 bg-theme-level5 text-theme-main appearance-none w-3/5 px-4 py-2 h-full leading-normal focus:outline-none rounded-full"
            v-model="searchQuery"
            @keydown.enter="performSearch"
            @keydown.esc="searchQuery=''"
            :placeholder="translate('admin-search-placeholder')" />
        <button
            type="button"
            class="ml-4 py-3 px-8 text-theme-control-label bg-theme-controls2 hover:bg-theme-controls1 rounded-lg focus:outline-none cursor-pointer"
            @click="performSearch"
        >{{ translate('admin-search-button') }}</button>
    </div>
</template>

<script>

    const Lang = require('lang.js');
    import translations from './messages.js';

    const lang = new Lang();

    lang.setMessages(translations);

    export default {

        data() {
            return {

                searchQuery: ''

            }
        },

        props: [
            'currentlocale'
        ],

        methods: {

            translate(key) {
                key = 'strings.' + key;
                return lang.get(key);
            },

            performSearch() {
                if(this.searchQuery !== '') {
                    window.location = '/' + this.currentlocale + '/admin/content/search/' + this.searchQuery ;
                } else {
                    this.flashMessage.info({
                            title: '',
                            message: this.translate('admin-search-error'),
                            blockClass: 'p-6',
                            time: 4000
                        });
                }
            }

        }

    }

</script>
